import Vue from "vue";
import { find } from "lodash";

export default {
	state: {
		listview: "list",
		appclasses: [],
		navigation: [
			{
				title: "Home",
				icon: "home",
				path: { name: "home" },
				expanded: false,
				children: []
			},
			{
				title: "Reports",
				icon: "user-chart",
				path: { name: "ReportsView" },
				expanded: false,
				children: [
					{
						title: "Hospital",
						path: { name: "ReportsHospitalsView" }
					},
					{
						title: "Hospital user",
						path: { name: "ReportsHospitalUsersView" }
					},
					{
						title: "Hospital market",
						path: { name: "ReportsHospitalMarketView" }
					},
					{
						title: "Listing",
						path: { name: "ReportsListingsView" }
					},
					{
						title: "Organisation user",
						path: { name: "ReportsOrganisationUserView" }
					},
					{
						title: "Global",
						path: { name: "ReportsGlobalView" }
					}
				]
			},
			{
				title: "Users",
				icon: "user",
				path: {
					name: "UsersListView",
					params: { listName: "access-customer" }
				},
				expanded: false,
				children: []
			},
			{
				title: "Organisations",
				icon: "users",
				path: { name: "OrganisationsList" },
				expanded: false,
				children: []
			},
			{
				title: "Listings",
				icon: "building",
				path: { name: "Listings" },
				expanded: false,
				children: []
			},
			{
				title: "Health services",
				icon: "medkit",
				path: { name: "HealthServicesList" },
				expanded: false,
				children: []
			},
			{
				title: "Hospitals",
				icon: "medkit",
				path: { name: "HospitalsList" },
				expanded: false,
				children: []
			},
			{
				title: "Home care",
				icon: "cube",
				path: { name: "HomeCareList" },
				expanded: false,
				children: []
			},
			{
				title: "Data maps",
				icon: "chart-area",
				path: { name: "DataMapsList", params: { type: "hospitals" } },
				expanded: false,
				children: []
			},
			{
				title: "Meetings",
				icon: null,
				path: "/bookings",
				expanded: false,
				children: [
					{
						title: "Site tours",
						path: { name: "BookingsSuperSiteTourView" }
					},
					{
						title: "Callouts",
						path: { name: "BookingsSuperCalloutView" }
					}
				]
			}
		],
		previewModal: false,
		detailsNavigation: []
	},
	getters: {
		navigation: (state, getters, rootState) => state.navigation,
		navigationwas: (state) => state.menu,
		listview: (state) => state.listview,
		appclasses: (state) => state.appclasses,
		// setting false state on getter as the debug function
		// is used across both apps in a component
		debug: () => false,
		previewModalState: (state) => state.previewModal,
		detailsNavigation: (state) => state.detailsNavigation
	},
	actions: {
		ListViewUpdate(context, view) {
			context.commit("setListView", view);
		},
		openPreviewState(context) {
			context.commit("previewState", ["preview-open"]);
		},
		closePreviewState(context) {
			context.commit("previewState", []);
		},
		vacancyEditorState(context) {
			context.commit("previewState", ["vacancy-editor"]);
		},
		previewModalState(context, status) {
			context.commit("previewModalState", status);
		},
		setDetailsNavigation(context, item) {
			context.commit("setDetailsNavigation", item);
		},
		updateDetailsNavigation(context, item) {
			context.commit("updateDetailsNavigation", item);
		}
	},
	mutations: {
		setListView(state, view) {
			state.listview = view;
		},
		previewState(state, view) {
			state.appclasses = view;
		},
		insertMetricsOption(state) {
			state.vacancyEditorMenu.splice(1, 0, state.metricsMenuOption);
		},
		previewModalState(state, status) {
			state.previewModal = status;
		},
		setDetailsNavigation(state, item) {
			/**
			 * We only want to add to the list if it does not exist. This method has
			 * the potential of being problematic. So may need to be revisted at a
			 * later date
			 */
			if (
				!state.detailsNavigation.filter(
					(link) => link.anchor === item.anchor
				).length
			) {
				if (state.detailsNavigation.length === 0) {
					item.active = true;
				}
				state.detailsNavigation.push(item);
			}
		},
		updateDetailsNavigation(state, { anchor, active }) {
			const menuitem = find(state.detailsNavigation, {
				anchor
			});
			Vue.set(menuitem, "active", active);
		}
	}
};
